import { render, staticRenderFns } from "@/templates/serviceDelivery/sdPendingDetails.html?vue&type=template&id=1ba0f7c8&"
import script from "./SDPendingDetails.vue?vue&type=script&lang=js&"
export * from "./SDPendingDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports